import { Fragment, memo } from 'react';
import PropTypes from 'prop-types';

import { formatDataTest } from '~/utils';

import styles from '../section/Section.scss';

export const SectionItem = memo(({ title, definition, dataTest }) => (
  <Fragment>
    <dt
      className={`${styles.Section__question_title} ${styles.Section__column}`}
      data-testid={formatDataTest(dataTest || title, 'title')}
    >
      {title}
    </dt>
    <dd
      className={`${styles.Section__question_definition} ${styles.Section__column}`}
      data-testid={formatDataTest(dataTest || title)}
    >
      {definition}
    </dd>
  </Fragment>
));

SectionItem.displayName = 'SectionItem';

SectionItem.propTypes = {
  title: PropTypes.string.isRequired,
  dataTest: PropTypes.string,
  definition: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
};
